import { render } from "./developAi.vue?vue&type=template&id=17d20bf6&scoped=true"
import script from "./developAi.vue?vue&type=script&lang=js"
export * from "./developAi.vue?vue&type=script&lang=js"

import "./developAi.vue?vue&type=style&index=0&id=17d20bf6&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17d20bf6"]])

export default __exports__